import crossingRealitiesLogo from '../assets/images/crossing-realities-logo.png';
import fitnessAppLogo from '../assets/images/fitness-app-logo.png';
import uefaLogo from '../assets/images/uefa-logo.png';


import { FaJava, FaReact, FaJs, FaFigma } from "react-icons/fa";
import { FaFlutter } from "react-icons/fa6";
import { PiFileCSharp } from "react-icons/pi";
import { SiLua } from "react-icons/si";
import { IoLogoFirebase } from "react-icons/io5";
import { AiOutlinePython } from "react-icons/ai";

export const text = {
    homepage: {
        hero: {
            nameEn: "Mouner Shami", 
            nameAr: "منير شامي",
            description: "A passionate and dedicated software developer from Nazareth. With a robust background in Mobile Applications, Web Development and Game Development. I bring a diverse skill set and a commitment to excellence in all my projects.",
            nav: [
                { id: "projects", label: "Projects" },
                { id: "intro", label: "Skills" },
                { id: "contact", label: "Contact" }
            ]
        },
        intro: {
            title: "INTRODUCTION",
            subtitle: "Hey, I’m Mouner Shami, A passionate developer specializing in web and software development. I build modern and efficient applications that solve real-world problems.",
            intoSubtitle: [
                {
                    title: "About Me",
                    text: "I’m a software developer with expertise in React, Python, and UI/UX design. I have a strong passion for building interactive applications and bringing creative ideas to life. Whether it’s a web app, game, or automation tool, I love turning ideas into reality. When I’m not coding, I’m exploring game development, music production, or graphic design.",
                },
                {
                    title: "About Portfolio",
                    text: "Welcome to my portfolio! Here, you’ll find a collection of my projects, designs, and experiences in web development, game development, and software engineering. Each project reflects my passion for creating modern, functional, and interactive applications. Explore my work and feel free to reach out if you're interested in collaborating!"
                },
            ],
            skillsTitle: "SKILLS",
            skills: [
                {
                    title: "Mobile Dev",
                    items: [
                        { id: "java", title: "Java", icon: <FaJava size={35}/> },
                        { id: "flutter", title: "Flutter", icon: <FaFlutter size={25}/> }
                    ]
                },
                {
                    title: "Web Dev",
                    items: [
                        { id: "react", title: "React", icon: <FaReact size={30}/>  },
                        { id: "javascript", title: "Javascript", icon: <FaJs size={25}/> }
                    ]
                },
                {
                    title: "Game Dev",
                    items: [
                        { id: "csharp", title: "C Sharp", icon: <PiFileCSharp size={30}/>  },
                        { id: "lua", title: "Lua", icon: <SiLua size={30}/> }
                    ]
                },
            ],
            otherSkills: {
                title: "Other Skills",
                items: [
                    { id: "firebase", title: "Firebase", icon: <IoLogoFirebase  size={35}/> },
                    { id: "figma", title: "Figma", icon: <FaFigma size={25}/> },
                    { id: "python", title: "Python", icon: <AiOutlinePython size={25}/> }
                ]
            }
        },
        projects: {
            title: "PROJECTS",
            filters: [ { id: "all", title: "All"}, { id: "coded", title: "Coded" }, { id: "designed", title: "Designed"}],
            projects: [
                {
                    title: "Crossing Realities",
                    description: "A unique game developed during Game Jam 2024. Navigate through multiple realities while solving puzzles and overcoming challenges. Built with Unity and C#.",
                    type: "Coded",
                    logo: crossingRealitiesLogo,
                    links: [ { id: "view", title: "View", link: "https://mounersh.itch.io/crossing-realities"}, { id: "github", title: "Github", link: "https://github.com/mouners/Crossing-Realities"} ]
                }, {
                    title: "Fitness Calculator",
                    description: "A comprehensive fitness application that helps users track their health metrics. Calculate BMR, TEE, and BMI with detailed explanations and personalized recommendations.",
                    type: "Mobile Apps",
                    logo: fitnessAppLogo,
                    links: [
                        { id: "view", title: "View", link: "https://play.google.com/store/apps/details?id=com.mounersh.fitnessapp"},
                        { id: "github", title: "Github", link: "https://github.com/mouners/FitnessApp"}
                    ]
                }, {
                    title: "UEFA Draw Simulator",
                    description: "An unofficial UEFA Champions League group stage draw simulator. Experience the excitement of the draw process with accurate rules and restrictions implementation.",
                    type: "Web Development",
                    logo: uefaLogo,
                    links: [
                        { id: "view", title: "View", link: "https://draw-04.web.app/"},
                        { id: "github", title: "Github", link: "https://github.com/mouners/Unofficial-Simulation-Draw"}
                    ]
                }
            ]
        },
        contact: {
            title: "CONTACT",
            subtitle: "Let's Connect",
            description: "Feel free to reach out for collaborations or just to say hello!",
            link: [
                {
                    id: 'linkedIn',
                    title: 'LinkedIn',
                    url: 'https://www.linkedin.com/in/mounersh/'
                },
                {
                    id: 'github',
                    title: 'GitHub',
                    url: 'https://github.com/mouners'
                },
                {
                    id: 'email',
                    title: 'Email',
                    url: 'mailto:mouner.shami@gmail.com'
                },
                {
                    id: 'fiverr',
                    title: 'Fiverr',
                    url: 'https://www.fiverr.com/mounersh'
                },
                
            ]
        }
    },
}; 